import React, {Component} from "react";
import {monthOptions, yearOptions} from "../../config";
import * as R from "ramda";
import {configMonthToDateSalesman} from "../config";
import {removeNullFields} from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class MonthToDateSalesmanReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
    };
  }

  componentDidMount = async () => {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1
      ),
      year: yearOptions.find((item) =>
        R.equals(item.value, currentDate.getFullYear())
      ),
      tableConfig: configMonthToDateSalesman,
    }));
  };

  componentDidUpdate = async (prevProps, prevState, snapshot) => {
    if (!R.equals(prevProps.search, this.props.search)) {
      this.handleSearch();
    }
  };

  transformResponseToTable = (data) => {
    return [
      ...data.data,
      {
        name: "Total",
        lastMonth: data.totalLastMonth,
        thisMonth: data.totalThisMonth,
        growth: data.growth,
        forecasting: data.totalForecasting,
      },
    ];
  };

  fetchData = async () => {
    try {
        this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanMTDSalesmanCS,
        setError: this.props.setError,
        menuName: "Dashboard Level Kacab - Laporan Jualan MTD Salesman CS",
        args: {
          kodeCabang: [this.props.search],
          year: this.state.year?.value,
          month: this.state.month?.value,
          mode: "SALESMAN",
          idLeader: this.props.idLeader
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: this.transformResponseToTable(res.data.data),
        }));
      }
      this.props.triggerLoading();
    } catch (error) {
        this.props.triggerLoading();
      console.error("Error fetching data:", error);
    }
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () =>{
    this.fetchData()
  }

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            isClearable
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            isClearable
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={()=>this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
        />
      </>
    );
  }
}

export default MonthToDateSalesmanReport;